import React from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';

import './index.sass';

const { el } = bem('education');

const Education = ({ institute, speciality, qualification, graduationYear, yearsOfStudy }) => {
    const year = graduationYear ? graduationYear : yearsOfStudy;

    return (
        <>
            <div className={ el('left-block') }>
                <div className={ el('year') }>
                    <Text serif>{ year }</Text>
                </div>
                <div className={ el('dash') }/>
            </div>
            <div className={ el('right-block') }>
                <div className={ el('institute') }>
                    <Text serif>{ institute }</Text>
                </div>
                <div className={ el('qualification') }>
                    { speciality && <Text tag={'div'}>{ speciality }</Text> }
                    { qualification && <Text tag={'div'}>{ qualification }</Text> }
                </div>
            </div>
        </>
    )
};

export default Education;
